import React from 'react'
import { Link, useHref } from 'react-router-dom'
import textMk from '../../../js/textMk'

const tabs = [
    {
        label: "New",
        href: "/case/add"
    },
    {
        label: "Drafts",
        href: "/case/add/drafts"
    },
]
export default function Tabs() {

    const href = useHref()


    return (
        <div className='tabs'>
            {tabs.map(d=><Link to={d.href} className={textMk('tab', d.href == href && 'active')}>{d.label}</Link>)}
        </div>
    )
}
